<template>
  <!-- 该组件样式依赖了AttributeBar组件，一旦脱离，注意样式变化 -->
  <div class="btn-font-config" :class="{ 'choosen': playing }" @click="play">
    <i v-if="playing" class="ico-audio-stop icon-btn"></i>
    <i v-else class="ico-audio-play icon-btn"></i>
    {{ playing ? '停' : '听' }}
    <audio style="display: none;" ref="audioRef" src="./emptyVoice.mp3" controls @ended="playNext"></audio>
  </div>
</template>

<script>
import md5 from 'md5';
import { splitStr } from '@/views/detailPage/utils/tts';
import { Toast as toast } from 'vant';
const num_2 = 2;
const num_3 = 3;
const num_4 = 4;
const audioBusyMessage = '当前用户过多，请稍后再试';
export default {
  name: 'v-voice',
  data() {
    return {
      // 0为初始状态，1播放中，2暂停 3播放结束 4播放异常状态
      state: 0,
      listIndex: -1,
      loading: false,
      title: '',
      audioList: [],
      content: '',
      contentList: [],
    };
  },
  computed: {
    playing() {
      return this.state === 1 || this.loading === true;
    }
  },
  mounted() {
    this.$refs.audioRef.addEventListener('durationchange', () => {
      if (this.audioList.length) {
        this.$refs.audioRef.play();
      }
    });
  },
  components: {
    [toast.name]: toast,
  },
  methods: {
    initContent() {
      const s = document.getElementsByClassName('article-content')[0].innerHTML;
      let content = s;
      const tabReg = /<table[^>]*>\s*(<tbody[^>]*>)?(\s*<tr[^>]*>[\s\S]*?<\/tr>\s*)*(<\/tbody>)?\s*<\/table>/gi;
      const tabMatch = tabReg.test(content);
      if (tabMatch) {
        content = s.replace(tabReg, '');
      }
      this.title = document.getElementsByClassName('title')[0].innerText;
      const dom = document.createElement('div');
      dom.innerHTML = content;
      this.content = dom.innerText.replace('表格支持左右滑动', '');
    },
    playNext() {
      this.listIndex++;
      if (this.audioList.length > this.listIndex) {
        const item = this.audioList[this.listIndex];
        if (item.type === 'error') {
          toast({
            message: audioBusyMessage,
          });
          this.state = 4;
          return;
        } else {
          this.$refs.audioRef.src = this.audioList[this.listIndex].url;
          this.$refs.audioRef.load(); // 加载音频文件
        }
      } else {
        // 如果片段数量不相等，证明期间断网过，需要重新下载
        if (this.audioList[0].sum === this.audioList.length) {
          this.state = 3;
        } else {
          this.state = 4;
        }
      }
    },
    play() {
      if (!this.content) {
        this.initContent();
      }
      if (this.state === 0) {
        this.loading = true;
        this.beginPlay();
        // ios环境下，没有交互无法播放问题,而放在异步promise下，浏览器检测不到，不认为是交互。所以需要提前play一下
        this.$refs.audioRef.play();
        this.$refs.audioRef.pause();
      } else if (this.state === 1) {
        this.pausePlay();
      } else if (this.state === num_2) {
        this.state = 1;
        this.$refs.audioRef.play(); // 播放
      } else if (this.state === num_3) {
        this.state = 1;
        this.listIndex = -1;
        this.playNext();
      } else if (this.state === num_4) {
        if (this.ws) {
          this.ws.close();
          this.ws = null;
        }
        this.state = 0;
        this.listIndex = -1;
        this.audioList = [];
        this.beginPlay();
      } else {
        throw new Error('state数值不合法');
      }
    },
    beginPlay() {
      if (this.ws) {
        return;
      }
      const that = this;
      const ws = new WebSocket('wss://tellus.10jqka.com.cn/ths-tts');
      this.ws = ws;
      this.contentList = splitStr(this.title + this.content);
      ws.onopen = function () {
        that.sendNext();
      };
      ws.onmessage = function (e) {
        // 预防临时断网后，ws不断开
        if (that.ws !== ws) {
          ws.close();
          return;
        }
        try {
          const { code, data, note } = JSON.parse(e.data);
          if (code === 1) {
            that.dealWithMessage(data);
          } else {
            // 数据出问题时关闭链接，读到这条内容的时候弹窗提示
            ws.close();
            that.ws = null;
            if (that.audioList.length === 0) {
              toast({
                message: audioBusyMessage,
              });
              that.loading = false;
            } else {
              that.audioList.push({
                url: '',
                type: 'error',
                msg: note,
              });
            }
          }
        } catch (err) {
          toast({
            message: audioBusyMessage,
          });
          that.loading = false;
          ws.close();
          that.ws = null;
          throw new Error(err);
        }
      };
    },
    // 处理数据
    dealWithMessage(data) {
      this.audioList.push({
        url: `data:audio/mp3;base64,${data.data}`,
        type: 'url',
        sum: data.sum
      });
      // 如果是第一段的第一片，接收并且播放
      if (data.order === 0 && this.state === 0) {
        this.state = 1;
        this.loading = false;
        this.$refs.audioRef.play();
        // 如果是本段最后一片 判断是否开启下一段
      } else if (data.order === data.sum - 1) {
        // 还有下一段
        if (this.contentList.length) {
          this.sendNext();
        } else {
          // 最后一段
          this.ws.close();
          this.ws = null;
        }
      } else {
        return;
      }
    },
    pausePlay() {
      this.state = num_2;
      this.$refs.audioRef.pause();
    },
    sendNext() {
      const ts = new Date().getTime();
      const param = JSON.stringify({
        appId: '903E79F68A524464BB20210702153926',
        engineName: 'yuexiaohua',
        text: this.contentList[0],
        speed: 100,
        vol: 100,
        audioType: 1,
        endsil: 1,
        pitch: 0,
      });
      const secretKey = md5(`1611AE71FD358FA89D47956B9B47A0DA${param}${ts}`);
      this.ws.send(JSON.stringify({
        param,
        secretKey,
        ts
      }));
      this.contentList.shift();
    },
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
};
</script>

<style lang="less" scoped>
.btn-font-config {
  &.choosen {
    color: #fff;
    background: #0A5AFF;
  }
}

.night {
  .btn-font-config {
    &.choosen {
      background: #0A5AFF;
    }
  }
}

.icon-btn {
  line-height: 30px;
  height: 30px;
  margin-right: 4px;
}
</style>
